function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, message, Space, Alert } from 'antd';
import { SendFill } from 'react-bootstrap-icons';
import axios from 'axios';
import Common from '../includes/Common';
import { Spinner } from 'react-bootstrap';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var UserSuggestionBox = function UserSuggestionBox() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    mailSending = _useState2[0],
    setMailSending = _useState2[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState3 = useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState(""),
    _useState6 = _slicedToArray(_useState5, 2),
    successMessage = _useState6[0],
    setSuccessMessage = _useState6[1];
  var onMailSubmit = function onMailSubmit(values) {
    setMailSending(true);
    var formData = new FormData();
    formData.append('name', values.name);
    formData.append('email', values.email);
    formData.append('phone', values.phone);
    formData.append('content', values.content);
    axios.post(Common.baseApiUrl + 'sendemail', formData).then(function (response) {
      setMailSending(false);
      if (response.data.status == 200) {
        setSuccessMessage(response.data.message);
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setMailSending(false);
    });
  };
  useEffect(function () {
    form.setFieldsValue({
      name: '',
      email: '',
      phone: '',
      content: ''
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h3", {
      children: "Des suggestions ?"
    }), /*#__PURE__*/_jsx("h5", {
      children: "Aidez-nous \xE0 ameliorer le service"
    }), /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      onFinish: onMailSubmit,
      form: form,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), successMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "success",
          message: successMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "name",
        rules: [{
          required: true,
          message: 'Veuillez enter votre nom'
        }],
        label: "Votre nom",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "email",
        label: "E-mail",
        rules: [{
          type: 'email'
        }],
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "phone",
        rules: [{
          required: true,
          message: 'Veuillez entrer votre numéro'
        }],
        label: "T\xE9l\xE9phone",
        children: /*#__PURE__*/_jsx(Input, {})
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "content",
        rules: [{
          required: true,
          message: 'Veuillez enter votre suggestion'
        }],
        lable: "Suggestions",
        children: /*#__PURE__*/_jsx(TextArea, {
          placeholder: "Suggestion",
          autoSize: {
            minRows: 2,
            maxRows: 6
          }
        })
      }), /*#__PURE__*/_jsxs(Space, {
        direction: "horizontal",
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "submit",
          children: /*#__PURE__*/_jsx(Button, {
            type: "default",
            htmlType: "submit",
            children: /*#__PURE__*/_jsx(SendFill, {})
          })
        }), mailSending ? /*#__PURE__*/_jsx(Spinner, {
          animation: "grow"
        }) : /*#__PURE__*/_jsx(_Fragment, {})]
      })]
    })]
  });
};
export default UserSuggestionBox;